import * as angular from 'angular';
import * as angularTranslate from 'angular-translate';

import { mediaModel } from '../models/media';
import opentokSessionModule from '../models/opentok-session';
import { goPlayerControls } from '../player-controls';

import { mediaPlayerServicesModule } from './services';
import { GoMediaPlayer } from './adapters/media-player';
import type { PlaylistItem as ExportPlaylistItem } from './playlist-item';
import { EVENTS } from './events';
import { STATES } from './states';
import { PROVIDERS } from './providers';
import type { Options as ExportOptions } from './options';
import goMediaPlayerComponent from './media-player.component';
import { allPlayersServiceModule } from '@go-modules/services/all-players';

import './style.less';
import { ngxMediaAnalyticsServiceModule } from '@go-modules/services/media/analytics';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';
import { downgradeComponent } from '@angular/upgrade/static';
import { NetworkIndicatorComponent } from '@go-modules/components/network-indicator/network-indicator.component';
import { ngxMediaRecordingStatsModule } from '@go-modules/services/media-recording-stats';

export {
	GoMediaPlayer,
	EVENTS,
	STATES,
	PROVIDERS
};

export type Options = ExportOptions;
export type PlaylistItem = ExportPlaylistItem;

export const mediaPlayerModule = angular.module('mediaPlayer', [
	angularTranslate,
	mediaPlayerServicesModule,
	goPlayerControls,
	mediaModel,
	opentokSessionModule,
	allPlayersServiceModule,
	ngxMediaAnalyticsServiceModule,
	ngxFeatureFlagServiceModule,
	ngxMediaRecordingStatsModule
])
	.directive('ngxNetworkIndicator', downgradeComponent({ component: NetworkIndicatorComponent }) as angular.IDirectiveFactory)
	.component('goMediaPlayer', goMediaPlayerComponent)
	.name;
